module.exports = __webpack_public_path__ + "img/crown-number-two.017fe116.svg";